import { filter } from 'lodash-es';
import StoreCard from '@maison/components/store/StoreCard';
import { mapGetters } from 'vuex';

export default {
  components: { StoreCard },

  data: () => ({
    shouldSeparateBoutiquesFromRetailers: true,
  }),

  props: {
    resultText: {
      type: String,
      default: '',
    },
    stores: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters('storeSearch', ['hasResults']),

    boutiques() {
      return filter(this.stores, { type: 'boutique' });
    },

    retailers() {
      return filter(this.stores, { type: 'reseller' });
    },

    formattedResultText() {
      return this.resultText
        .replace('{boutique_count}', this.boutiques.length)
        .replace('{reseller_count}', this.retailers.length);
    },

    hasBoutiques() {
      return this.boutiques.length > 0;
    },

    hasRetailers() {
      return this.retailers.length > 0;
    },
  },
};
